import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import "regenerator-runtime/runtime";

class ManagerBase extends Controller {
	constructor (name) {
		super(name);

		this.remoteClassName = "";
	}

	async sendRequest (request, requestedAction) {
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, request)
		.then(data => {
			// console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						return {
							data,
							requestedAction,
							status: "ok"
						};
					}
					default:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	async delete (itemList) {
		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const rd = NousCore.api.createRequest({ items: itemList.map(item => {return {guid: item.guid}; }) });
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
	
	async getByGuid (guid) {
		const rd = NousCore.api.createRequest({item: { guid } });
		const requestedAction = "get-by-guid";

		return await NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}


	async getList (filters, item) {
		const rd = NousCore.api.createRequest({item});
		const requestedAction = "get-list";
	
		if (filters) {
			rd.filters = filters;
		}

		const result = await this.sendRequest(rd, requestedAction);
		
		if (result?.status === "ok") {
			const itemList = Shark.getInstanceList(this.responsesModelClass, result.data.items);

			result.data = itemList;
			// return {
			// 	data: itemList,
			// 	requestedAction,
			// 	status: result.status,
			// };
		}

		return result;

		// return NousCore.api.send("client/get-list", rd)
		// .then(data => {
		// 	if (data.isSuccess) {
		// 		switch (data.rc) {
		// 			case 1: {
		// 				const clientList = Shark.getInstanceList(this.responsesModelClass, data.items);
	
		// 				clientList.sort((a, b) => {
		// 					if (a.name.toLowerCase() > b.name.toLowerCase()) {
		// 						return 1;
		// 					}
		// 					else if (a.name.toLowerCase() < b.name.toLowerCase()) {
		// 						return -1;
		// 					}
		// 				});
	
		// 				Shark.set({clientList});
						
		// 				return {
		// 					data: clientList,
		// 					status: "ok"
		// 				};
		// 			}
		// 		}
		// 	}
		// });
	}


	// getList2 (filters) {
	// 	const rd = NousCore.api.createRequest();
	// 	const requestedAction = "get-list";

	// 	if (filters) {
	// 		rd.filters = filters;
	// 	}

	// 	return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					return {
	// 						data: data.items,
	// 						requestedAction,
	// 						status: "ok"
	// 					};
	// 				case 404:
	// 					return {
	// 						data,
	// 						requestedAction,
	// 						status: "ko"
	// 					};
	// 			}
	// 		}
	// 	});
	// }

	// getList (filters) {
	// 	const rd = NousCore.api.createRequest();
	// 	const requestedAction = "get-list";

	// 	if (filters) {
	// 		rd.filters = filters;
	// 	}

	// 	return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					return {
	// 						data: data.items,
	// 						requestedAction,
	// 						status: "ok"
	// 					}
	// 				case 404:
	// 					return {
	// 						data,
	// 						requestedAction,
	// 						status: "ko"
	// 					}
	// 			}
	// 		}
	// 	});
	// }

	getListByUserGuid (userGuid) {
		const rd = NousCore.api.createRequest({ item: { userGuid } });
		const requestedAction = "get-by-user-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
	
	// getMyList (filters) {
	// 	const rd = NousCore.api.createRequest();
	// 	const requestedAction = "get-my-list";

	// 	if (filters) {
	// 		rd.filters = filters;
	// 	}

	// 	return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					return {
	// 						data: data.items,
	// 						requestedAction,
	// 						status: "ok"
	// 					};
	// 				case 404:
	// 					return {
	// 						data,
	// 						requestedAction,
	// 						status: "ko"
	// 					};
	// 			}
	// 		}
	// 	});
	// }

	async save (itemList) {
		let actions = new Set();

		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const itemsToInsert = [];
		const itemsToUpdate = [];

		itemList.forEach(item => {
			actions.add(item.guid === "" ? "insert" : "update");
			if (item.guid === "") {
				itemsToInsert.push(item);
			}
			else {
				itemsToUpdate.push(item);
			}
		});

		// if (actions.size > 1) {
		// 	// Dave: A tendere, anziché dare errore dovrei raggruppare una chiamata per insert e una per update
		// 	alert("Non posso proseguire perché hai mescolato insert e update")
		// 	return;
		// }
		
		// const rd = NousCore.api.createRequest({ item: itemList[0].export() });
		let insertPromise;
		let updatePromise;

		if (itemsToInsert.length > 0) {
			const rd = NousCore.api.createRequest({ items: itemsToInsert.map(item => item.export()) });
			const requestedAction = "insert";

			insertPromise = NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
			.then(data => {
				if (data.isSuccess) {
					switch (data.rc) {
						case 1:
							itemsToInsert.forEach((item, index) => {
								item.import(data.items[index]);
								item.clean();
							});

							return {
								data: itemsToInsert,
								requestedAction,
								status: "ok",
							};
						case 99:
							return {
								data,
								requestedAction,
								status: "ko",
							};
					}
				}
			});
		}
		if (itemsToUpdate.length > 0) {
			const rd = NousCore.api.createRequest({ items: itemsToUpdate.map(item => item.export()) });
			const requestedAction = "update";

			updatePromise = NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
			.then(data => {
				if (data.isSuccess) {
					switch (data.rc) {
						case 1:
							itemsToUpdate.forEach((item, index) => {
								item.import(data.items[index]);
								item.clean();
							});

							return {
								data: itemsToUpdate,
								requestedAction,
								status: "ok",
							};
						case 99:
							return {
								data,
								requestedAction,
								status: "ko",
							};
					}
				}
			});
		}

		return Promise.all([insertPromise, updatePromise]);
	}

	search (filters) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}
}

export default ManagerBase;
